import { Menu } from '@mantine/core';

export const Divider: React.FC = () => {
  return <Menu.Divider />;
};
